import DesktopLayout from '../../layouts/DesktopLayout';
import AbortContent from '../shared/AbortContent';
import { type AbortVariant } from '../../types';

type Props = {
  errorCode?: number;
  errorMessage?: string;
  variant?: AbortVariant;
  onReject?: () => void;
  onRestart?: () => void;
  onBack?: () => void;
};

export default function DesktopAbortPage({ errorMessage: _, ...rest }: Props) {
  return (
    <DesktopLayout>
      <AbortContent {...rest} buttonDirection="row" />
    </DesktopLayout>
  );
}
